import { makeStyles } from "@cirrus/ui-kit";
import {DefaultColors} from "@cirrus/legacy/app-components/app/styles/colors/colors-default";

export const useStyles = makeStyles({
  controls: {
    display: "none",
    // display: "flex",
    textAlign: "center",
    color: DefaultColors.white,
    background: DefaultColors.gray_905,
    borderRadius: "4px",
    width: "350px",
    height: "40px",
    padding: "0 10px",
    alignItems: "center",
    justifyContent: "space-between",
    position: "absolute",
    bottom: "10px",
    left: "calc(50% - 175px)",
    zIndex: "2"
  },
  icon: {
    borderRadius: "4px",
    fontSize: "14px",
    marginRight: "10px",
    position: "relative",
    height: "30px",
    width: "30px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",

    "&:hover": {
      backgroundColor: DefaultColors.gray_300,
    }
  },
  fitWidth: {
    fontSize: "18px"
  },
  section: {
    display: "flex",
    alignItems: "center"
  },
  pager: {
    verticalAlign: "top",
    marginRight: "30px",
    fontSize: "12px",
  },
  input: {
    width: "30px",
    height: "25px",
    marginLeft: "10px",
    marginRight: "5px",
    padding: "0 4px",
    textAlign: "right",
    position: "relative",
  },
  pagerNumber: {
    position: "relative",
    top: "-1px"
  }
})

